<footer fxLayoutAlign="center center" fxLayout="row" fxLayout.xs="column" fxLayoutGap="2%">
  <span class="copy">
    &copy; {{ year }} RoboBanker
  </span>
</footer>